import React from "react";

import { OPTION_TYPE_ACCESS } from "../../../../helpers/config";
import { FieldFeedback, FormValidationNotice, RequiredMark } from "../../../../components/FormValidation";
import useFormValidation from "../../../../hooks/useFormValidation";
import { validationRules as rule } from "../../../../utils/helpers/formValidation";

const permissionSchema = {
  type: rule.required("Tipe permission wajib dipilih."),
  name: rule.required("Nama permission wajib diisi."),
  slug: rule.required("Slug permission wajib diisi."),
};
const FormPermission = (props) => {
  const { isShowModal: _isShowModal, isEdit, closeModal, formState, setFormState, handleAdd, handleUpdate } = props;
  const validation = useFormValidation({ values: formState, schema: permissionSchema, formId: "permission" });
  const submit = async (event) => {
    event.preventDefault();
    if (!validation.validateAll()) return;
    const success = isEdit ? await handleUpdate() : await handleAdd();
    if (success !== false) document.querySelector("#modal-form .btn-close")?.click();
  };

  return (
    <div
      className="modal modal-blur fade "
      id="modal-form"
      tabIndex="-1"
      permission="dialog"
      aria-hidden="false"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.3)",
      }}>
      <div className="modal-dialog modal-dialog-centered modal-lg" permission="document">
        <form className="modal-content" onSubmit={submit} noValidate>
          <div className="modal-header">
            <h5 className="modal-title">Master Permission {!isEdit ? "Baru" : "Edit"}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}></button>
          </div>
          <div className="modal-body">
            <FormValidationNotice errors={validation.errors} />
            <div className="row flex flex-col gap-3">
              <div className="col-lg-12">
                <label className="form-label">Tipe Akses / Permission<RequiredMark /></label>
                <div className="form-selectgroup" data-validation-field="type" tabIndex="-1" onBlur={() => validation.validateField("type")}>
                  {OPTION_TYPE_ACCESS.map((permission) => (
                    <label key={permission.value} className={`form-selectgroup-item `}>
                      <input
                        type="radio"
                        name="permission-type"
                        value={permission.value}
                        className="form-selectgroup-input"
                        checked={formState.type === permission.value}
                        onChange={() =>
                          setFormState((prev) => ({
                            ...prev,
                            type: permission.value,
                            name: permission.value + " ",
                            slug: permission.value + " ",
                          }))
                        }
                      />

                      <span
                        className={`form-selectgroup-label rounded-5 flex gap-3 ${permission.color}
                      ${formState.type === permission.value ? "fw-bold border-dark " : ""}`}>
                        <span className={`me-2 ${formState.type === permission.value ? "fw-bold " : ""}`}>
                          {permission.icon}
                        </span>
                        {permission.label}
                      </span>
                    </label>
                  ))}
                </div>
                <FieldFeedback formId="permission" name="type" error={validation.errors.type} hint="Pilih jenis akses yang sesuai." />
              </div>
              <div className="col-lg-12">
                <label className="form-label">Nama Akses / Permission<RequiredMark /></label>
                <div className="input-icon">
                  <span className="input-icon-addon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-table-plus">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5" />
                      <path d="M3 10h18" />
                      <path d="M10 3v18" />
                      <path d="M16 19h6" />
                      <path d="M19 16v6" />
                    </svg>
                  </span>
                  <input
                    {...validation.fieldProps("name")}
                    type="text"
                    className={validation.inputClass("name")}
                    placeholder="permission"
                    value={formState?.name || ""}
                    onChange={(e) =>
                      setFormState((prev) => ({
                        ...prev,
                        name: e.target.value,
                        slug: e.target.value === "" ? "" : e.target.value.toLowerCase().replace(/ /g, "-"),
                      }))
                    }
                  />
                  <FieldFeedback formId="permission" name="name" error={validation.errors.name} hint="Nama permission harus unik." />
                </div>
              </div>
              <div className="col-lg-12">
                <label className="form-label">Slug<RequiredMark /></label>
                <div className="mb-3 input-icon">
                  <span className="input-icon-addon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-link">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M9 15l6 -6" />
                      <path d="M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" />
                      <path d="M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" />
                    </svg>
                  </span>
                  <input
                    {...validation.fieldProps("slug")}
                    type="text"
                    disabled
                    className={validation.inputClass("slug")}
                    placeholder="slug"
                    value={formState?.slug || ""}
                    onChange={(e) =>
                      setFormState((prev) => ({
                        ...prev,
                        slug: e.target.value,
                      }))
                    }
                  />
                  <FieldFeedback formId="permission" name="slug" error={validation.errors.slug} hint="Dibuat otomatis dari nama permission." />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-link link-secondary btn-3" data-bs-dismiss="modal">
              {" "}
              Cancel{" "}
            </button>
            {isEdit ? (
              <button
                type="submit"
                className="btn btn-primary btn-5 ms-auto"
                >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-edit">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                  <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                  <path d="M16 5l3 3" />
                </svg>
                Edit Data
              </button>
            ) : (
              <button type="submit" className="btn btn-primary btn-5 ms-auto">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-2">
                  <path d="M12 5l0 14" />
                  <path d="M5 12l14 0" />
                </svg>
                Tambah Data
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormPermission;
